var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 57,
    viewBox: "0 0 36 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7952 56.4391C8.41255 56.4391 4.21255 55.8913 0.195159 54.7957L0.351681 45.5609C4.1082 47.1783 7.96907 47.987 11.9343 47.987C15.7952 47.987 18.8473 47.1522 21.0908 45.4826C23.3865 43.7609 24.5343 41.3348 24.5343 38.2043C24.5343 34.9174 23.4126 32.4652 21.1691 30.8478C18.9256 29.1783 15.6908 28.3435 11.4647 28.3435C8.02125 28.3435 4.44733 28.9435 0.742985 30.1435L1.13429 0.87391H33.5343V9.0913H10.6821L10.3691 21.0652C11.4647 20.8565 12.4299 20.7261 13.2647 20.6739C14.1517 20.5696 15.1952 20.5174 16.3952 20.5174C20.1517 20.5174 23.4647 21.2217 26.3343 22.6304C29.256 23.987 31.4995 25.9435 33.0647 28.5C34.6821 31.0565 35.4908 34.0565 35.4908 37.5C35.4908 41.3609 34.5517 44.7261 32.6734 47.5957C30.8473 50.413 28.2126 52.6043 24.7691 54.1696C21.3778 55.6826 17.3865 56.4391 12.7952 56.4391Z",
    fill: "#0B5ED7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.8d73dd2340f834b10e0b17a76ff0f71b.svg";
export { ForwardRef as ReactComponent };